import React, { useEffect, useState } from "react";
import "./HeroSection.scss";

import { useTranslation } from "react-i18next";
import { isClosedDubai0400To1200 } from "../utils/time";
import LazyImage from "./LazyImage";

// Restaurant storefront; also preloaded in public/index.html (LCP image).
const HERO_IMAGE = "/images/hero-storefront.webp";

const HeroSection = () => {
  // Closed-hours unified (Dubai time 04:00–12:00)
  const [isClosed, setIsClosed] = useState(isClosedDubai0400To1200());
  const [isPromoVisible, setPromoVisible] = useState(() => {
    // Use a new storage key to avoid old sessions hiding the banner unexpectedly
    const KEY = "promoDismissedV2";
    try {
      return window.sessionStorage?.getItem(KEY) === "1" ? false : true;
    } catch (_) {
      return true;
    }
  });
  const [isPromoClosing, setPromoClosing] = useState(false);
  const [isPromoOpening, setPromoOpening] = useState(false);
  useEffect(() => {
    const id = setInterval(() => setIsClosed(isClosedDubai0400To1200()), 60000);
    return () => clearInterval(id);
  }, []);
  const { t, i18n } = useTranslation();
  const ICONS = {
    keeta: "/icons/keeta.svg",
    whatsapp: "/icons/whatsapp.webp",
  };
  return (
    <section className="hero" id="home">
      <div
        className="global-toast-stack"
        style={{
          position: "fixed",
          top: "84px",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1300,
          width: "min(680px, calc(100% - 32px))",
        }}
      >
        {isClosed && (
          <div
            className="global-toast"
            style={{
              background: "#fff5f5",
              color: "#b2181e",
              border: "1px solid rgba(178,24,30,.18)",
              borderRadius: 10,
              padding: "10px 12px",
              fontWeight: 800,
              boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
              textAlign: "center",
            }}
          >
            {t(
              "checkout.closedBanner",
              "We\u2019re currently closed (4:00–12:00). Ordering is disabled."
            )}
          </div>
        )}
        {isPromoVisible && (
          <div
            className={`global-toast promo ${isClosed ? "mt-8" : ""} ${
              isPromoClosing ? "is-exit" : isPromoOpening ? "is-enter" : ""
            }`}
            role="status"
            aria-live="polite"
          >
            <button
              type="button"
              className="global-toast__close"
              aria-label={
                i18n.language && i18n.language.startsWith("ar")
                  ? "إغلاق"
                  : "Close"
              }
              onClick={() => {
                // play exit animation then hide
                setPromoClosing(true);
                window.setTimeout(() => {
                  setPromoClosing(false);
                  setPromoVisible(false);
                  try {
                    window.sessionStorage?.setItem("promoDismissedV2", "1");
                  } catch (_) {}
                }, 380);
              }}
            >
              ×
            </button>
            <span className="promo-text">
              {i18n.language && i18n.language.startsWith("ar")
                ? " اطلب من موقعنا وستحصل على خصم يصل الى 35 %"
                : "Order from our website and get up to 35% OFF"}
            </span>
          </div>
        )}
        {!isPromoVisible && (
          <button
            type="button"
            className="promo-reopen-btn"
            onClick={() => {
              setPromoVisible(true);
              setPromoOpening(true);
              try {
                window.sessionStorage?.removeItem("promoDismissedV2");
              } catch (_) {}
              window.setTimeout(() => setPromoOpening(false), 420);
            }}
            aria-label={
              i18n.language && i18n.language.startsWith("ar")
                ? "عرض العرض"
                : "Show offer"
            }
            title={
              i18n.language && i18n.language.startsWith("ar")
                ? "عرض العرض"
                : "Show offer"
            }
          >
            {i18n.language && i18n.language.startsWith("ar")
              ? "إظهار العرض"
              : "Show offer"}
          </button>
        )}
      </div>
      <div className="hero-content">
        <div className="right-side">
          <div className="hero-photo">
            <img
              src={HERO_IMAGE}
              alt={
                i18n.language && i18n.language.startsWith("ar")
                  ? "مطعم شاورما دوز في بزنس باي، دبي"
                  : "Shawarma Dose restaurant in Business Bay, Dubai"
              }
              className="hero-photo__img"
              width={1536}
              height={1024}
              fetchPriority="high"
              decoding="async"
            />
          </div>
        </div>

        <div className="left-text-side">
          <h1>Shawarma Dose</h1>
          <p className="tagline">
            Dubai&apos;s Favorite Authentic Shawarma Delivered Fresh in Minutes
          </p>
          <div className="cta-buttons">
            <div className="dropdown">
              <div className="order-now-btn no-interaction">Order Now</div>
              <div className="dropdown-menu show-always">
                <a
                  href="https://url-eu.mykeeta.com/0HnsAESz"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LazyImage src={ICONS.keeta} alt="Keeta" />
                </a>
                {isClosed ? (
                  <button
                    type="button"
                    className="wa-link"
                    aria-disabled={true}
                    title="Closed 4:00–12:00"
                    onClick={(e) => e.preventDefault()}
                    style={{
                      background: "transparent",
                      border: "none",
                      padding: 0,
                      opacity: 0.5,
                      cursor: "not-allowed",
                    }}
                  >
                    <LazyImage src={ICONS.whatsapp} alt="WhatsApp" />
                  </button>
                ) : (
                  <a
                    href="https://wa.me/971527818944"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="wa-link"
                  >
                    <LazyImage src={ICONS.whatsapp} alt="WhatsApp" />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
